<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('rider.list.title') }}</span>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('common.riderStatus')">
              <el-select v-model="formInline.isWork" :placeholder="$t('common.pleaseSelect')" @change="fetchData">
                <el-option :label="$t('common.all')" :value="''"></el-option>
                <el-option :label="$t('common.online')" value="1"></el-option>
                <el-option :label="$t('common.offline')" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('rider.list.name')">
              <el-input v-model="formInline.userName" size="medium" :placeholder="$t('rider.list.namePh')" @input="fetchData"></el-input>
            </el-form-item>
            <el-form-item :label="$t('rider.list.tel')" class="mar_l20">
              <el-input v-model="formInline.tel" size="medium" :placeholder="$t('rider.list.telPh')" @input="fetchData"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="userName" :label="$t('common.riderAccount')"></el-table-column>
        <el-table-column prop="name" :label="$t('common.realName')" align="center"></el-table-column>
        <el-table-column prop="tel" :label="$t('common.contact')" align="center"></el-table-column>
        <el-table-column prop="levelName" :label="$t('common.riderLevel')" align="center"></el-table-column>
        <el-table-column prop="isWork" :label="$t('common.workStatus')" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isWork == 1" style="color: #1bb93a;">{{ $t('common.online') }}</div>
            <div v-if="scope.row.isWork == 2" style="color: #999;">{{ $t('common.offline') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" :label="$t('common.orderCountToday')" align="center" min-width="150">
          <template slot-scope="scope">
            <div class="flex flex-justify-center">
              <section class="debug-d debug-trip" style="background: #2a75ed;">{{ $t('common.today') }}</section>
              <span>?</span>
              <span style="color: #2a75ed; min-width: 50px;">{{ scope.row.todayOrderNum }}</span>
            </div>
            <div class="flex flex-justify-center mar_t20">
              <section class="debug-d debug-trip" style="background: #FF8000;">{{ $t('common.total') }}</section>
              <span>?</span>
              <span style="color: #FF8000; min-width: 50px;">{{ scope.row.orderNum }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.withdrawable')" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="flex flex-justify-center">
              <section class="debug-d debug-trip" style="background: #999;">{{ $t('common.paid') }}</section>
              <span>?</span>
              <span style="color: #999; min-width: 50px;">{{ scope.row.finance || '0.00' }}</span>
            </div>
            <div class="flex flex-justify-center mar_t20">
              <section class="debug-d debug-trip" style="background: #67c23a;">{{ $t('common.pending') }}</section>
              <span>?</span>
              <span style="color: #67c23a; min-width: 50px;">{{ scope.row.useCommission || '0.00' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="bond" :label="$t('common.bond')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.isBond == '1' ? $t('common.paidBond') : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('common.status')">
          <template>
            <div class="flex">
              <section class="debug-d debug-small"></section>
              <div style="color: #2a75ed;">{{ $t('common.certified') }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" :label="$t('common.regTime')"></el-table-column>
        <el-table-column :label="$t('common.operation')" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="flex">
              <el-button type="text" @click="handleSee(scope.row.id)">{{ $t('common.view') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="10" :current-page.sync="formInline.page" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>
<script>
import { riderList, deleteRider } from '@/api/rider';
export default {
  data() {
    return {
      formInline: {
        isWork: '',
        userName: '',
        tel: '',
        page: 1
      },
      list: [],
      listLoading: true,
      selectRows: '',
      page: {
        total: 0
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleSee(id) {
      this.$router.push({
        name: 'riderEditInfo',
        query: { id, routerName: 'riderlist' },
      });
    },
    handleDelete(id) {
      if (id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await deleteRider({ id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    async fetchData() {
      const { data, count } = await riderList(this.formInline);
      this.list = (data || []).map((item) => {
        if (!item.name) item.name = this.$t('common.notCertified');
        return item;
      });
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.fetchData();
    }
  }
};
</script>
